export default function PlusIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="plus-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M24 38.5q-.85 0-1.425-.575Q22 37.35 22 36.5V26H11.5q-.85 0-1.425-.575Q9.5 24.85 9.5 24q0-.85.575-1.425Q10.65 22 11.5 22H22V11.5q0-.85.575-1.425Q23.15 9.5 24 9.5q.85 0 1.425.575Q26 10.65 26 11.5V22h10.5q.85 0 1.425.575.575.575.575 1.425 0 .85-.575 1.425Q37.35 26 36.5 26H26v10.5q0 .85-.575 1.425-.575.575-1.425.575Z"
      />
    </svg>
  );
}
